import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderSlot as _renderSlot, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "px-6"
};
import { computed, reactive } from 'vue';
import LlSecondaryButton from '@/components/LlSecondaryButton.vue';
export default {
  __name: 'LlConfirmationDialog',
  props: {
    title: {
      type: String,
      default: 'Confirm'
    },
    message: {
      type: String,
      default: 'Are you sure?'
    },
    toggleText: {
      type: String,
      default: 'Cancel'
    },
    confirmText: {
      type: String,
      default: 'OK'
    },
    showWarningIcon: {
      type: Boolean,
      default: false
    },
    confirmColor: {
      type: String,
      default: ''
    },
    dataCy: {
      type: String,
      default: ''
    },
    preserveNewlines: {
      type: Boolean,
      default: false
    },
    confirmDisabled: {
      type: Boolean,
      default: false
    },
    // Backdrop click and Esc no longer close it, so the only exits are the two
    // buttons. For prompts whose whole job is to be answered.
    persistent: {
      type: Boolean,
      default: false
    },
    confirmVariant: {
      type: String,
      default: 'outlined'
    },
    cancelVariant: {
      type: String,
      default: undefined
    },
    cancelColor: {
      type: String,
      default: undefined
    },
    maxWidth: {
      type: [String, Number],
      default: 500
    }
  },
  emits: ['confirm', 'cancel'],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const props = __props;
    const emits = __emit;
    const state = reactive({
      isVisible: false
    });
    const textColor = computed(() => props.confirmColor || (props.showWarningIcon ? 'primary' : 'error'));
    let resolvePromise;
    function open() {
      state.isVisible = true;
      return new Promise(resolve => {
        resolvePromise = resolve;
      });
    }
    function close() {
      state.isVisible = false;
    }

    // Settles the pending open() exactly once.
    function settle(value) {
      const resolve = resolvePromise;
      resolvePromise = null;
      if (resolve) resolve(value);
    }
    function confirm() {
      emits('confirm');
      close();
      settle(true);
    }
    function cancel() {
      emits('cancel');
      close();
      settle(false);
    }

    // A backdrop click or Esc closes the v-dialog through its own update event,
    // never through confirm() or cancel() — which used to leave the promise pending
    // forever, and every caller awaiting it stuck. Closing without an answer is a
    // cancel. Handled here rather than in a watcher so it cannot depend on timing.
    function onVisibilityChange(visible) {
      state.isVisible = visible;
      if (!visible) settle(false);
    }

    // Expose the `open` function to make it accessible from the parent
    __expose({
      open
    });
    return (_ctx, _cache) => {
      const _component_v_card_title = _resolveComponent("v-card-title");
      const _component_v_icon = _resolveComponent("v-icon");
      const _component_v_card_text = _resolveComponent("v-card-text");
      const _component_v_spacer = _resolveComponent("v-spacer");
      const _component_v_card_actions = _resolveComponent("v-card-actions");
      const _component_v_card = _resolveComponent("v-card");
      const _component_v_dialog = _resolveComponent("v-dialog");
      return _openBlock(), _createBlock(_component_v_dialog, {
        "model-value": state.isVisible,
        persistent: __props.persistent,
        "onUpdate:modelValue": onVisibilityChange,
        "max-width": __props.maxWidth,
        "data-cy": __props.dataCy || 'll-confirmation-dialog'
      }, {
        default: _withCtx(() => [_createVNode(_component_v_card, null, {
          default: _withCtx(() => [_createVNode(_component_v_card_title, null, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(__props.title), 1)]),
            _: 1
          }), _createVNode(_component_v_card_text, {
            class: _normalizeClass({
              'whitespace-pre-line': __props.preserveNewlines
            })
          }, {
            default: _withCtx(() => [__props.showWarningIcon ? (_openBlock(), _createBlock(_component_v_icon, {
              key: 0,
              class: "mr-2",
              color: "warning"
            }, {
              default: _withCtx(() => [...(_cache[0] || (_cache[0] = [_createTextVNode("mdi-alert", -1)]))]),
              _: 1
            })) : _createCommentVNode("", true), _createTextVNode(" " + _toDisplayString(__props.message), 1)]),
            _: 1
          }, 8, ["class"]), _ctx.$slots.content ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_renderSlot(_ctx.$slots, "content")])) : _createCommentVNode("", true), _createVNode(_component_v_card_actions, {
            class: "pa-6"
          }, {
            default: _withCtx(() => [_createVNode(LlSecondaryButton, {
              variant: __props.cancelVariant,
              color: __props.cancelColor,
              onClick: cancel
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(__props.toggleText), 1)]),
              _: 1
            }, 8, ["variant", "color"]), _createVNode(_component_v_spacer), _createVNode(LlSecondaryButton, {
              variant: __props.confirmVariant,
              color: textColor.value,
              disabled: __props.confirmDisabled,
              onClick: confirm,
              "data-cy": "confirm-button"
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(__props.confirmText), 1)]),
              _: 1
            }, 8, ["variant", "color", "disabled"])]),
            _: 1
          })]),
          _: 3
        })]),
        _: 3
      }, 8, ["model-value", "persistent", "max-width", "data-cy"]);
    };
  }
};